import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { cn } from "@/lib/utils";

const STATES = {
  filtered: ["Filtered", "border-teal-200 bg-teal-50 text-teal-800"],
  partial: ["Partly filtered", "border-amber-200 bg-amber-50 text-amber-800"],
  unaffected: ["Not affected by this filter", "border-slate-200 bg-slate-50 text-slate-500"],
};

export const TileBadge = ({ status, testid }) => {
  if (!status) return null;
  const [label, cls] = STATES[status.state];
  const badge = (
    <span className={cn("inline-flex items-center rounded-full border px-2 py-0.5 text-[10.5px] font-semibold", cls)} data-testid={testid} data-state={status.state}>{label}</span>
  );
  return (
    <span className="inline-flex flex-col items-start gap-1">
      {status.state === "partial" ? (
        <TooltipProvider delayDuration={100}>
          <Tooltip>
            <TooltipTrigger asChild><span className="cursor-help">{badge}</span></TooltipTrigger>
            <TooltipContent className="max-w-xs text-xs" data-testid={`${testid}-tooltip`}>Not filtered (kept whole): {status.unaffected.join(", ")}</TooltipContent>
          </Tooltip>
        </TooltipProvider>
      ) : badge}
      {status.empty && <span className="text-[11px] text-slate-500" data-testid={`${testid}-empty`}>No records match these filters</span>}
    </span>
  );
};
